import {ActionCreator, createAction} from '@packages/utilities/create-action';
import {
  EMBED_EDITOR_HIDDEN,
  EMBED_EDITOR_SHOWN,
} from '@packages/systems/designer/actions';
import {type NativeId} from '@packages/systems/core/utils/NativeIdUtils';
import {type Expression} from '@packages/systems/wfdl-ast';

export const embedEditorShown: ActionCreator<
  typeof EMBED_EDITOR_SHOWN,
  {
    source: string;
    elementId?: NativeId;
    onSave?: ((expr: Expression) => void) | null;
    initialExpr?: Expression | null;
    showBindingDot?: boolean;
    isEditingDefault?: boolean;
  }
> = createAction(EMBED_EDITOR_SHOWN);

export const embedEditorHidden: ActionCreator<
  typeof EMBED_EDITOR_HIDDEN,
  void
> = createAction(EMBED_EDITOR_HIDDEN);
